import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <Link to="/" className="text-background-50 no-underline cursor-pointer">黄游网页版</Link>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              黄游网页版是您无需下载安装、直接在浏览器中畅玩的游戏平台。支持PC与手机端访问，海量游戏资源随时体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">游戏分类</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/category/role-playing" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">角色扮演</Link></li>
              <li><Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">动作格斗</Link></li>
              <li><Link to="/category/strategy" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">策略战争</Link></li>
              <li><Link to="/category/simulation" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">模拟经营</Link></li>
              <li><Link to="/category/adventure" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">冒险探索</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">快捷链接</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">关于我们</Link></li>
              <li><Link to="/article/article-003" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">新手指南</Link></li>
              <li><Link to="/article/article-005" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">游戏技巧</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>service@huangyou.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-customer-service-2-line text-base"></i>
                <span>在线客服：7x24小时</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 黄游网页版 - 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}